import PaymentsPage from "components/pages/PaymentsPage";

export default function CapturePaymentsPayments(props) {
    return <PaymentsPage />
}